<aside class="lf-app-menu">
  <lf-main-menu [topItems]="menu.topItems()" [bottomItems]="menu.bottomItems()"></lf-main-menu>
</aside>
<section class="lf-app-main">
  <router-outlet />
</section>
<lf-toasts-outlet />
